var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mb-3": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _vm.showAddButton
            ? _c(
                "v-btn",
                {
                  staticClass: "attachment-btn ma-0",
                  attrs: { color: "yellowLight", text: "", icon: "" },
                  on: { click: _vm.handleAddBlockPhoto }
                },
                [
                  _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                    _vm._v("add")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.fkFilenames, function(filename, index) {
        return _c(
          "v-flex",
          { key: index, attrs: { xs12: "" } },
          [
            _c(
              "v-layout",
              { attrs: { row: "", "fill-height": "", "mt-3": "", "mb-1": "" } },
              [
                !_vm.editMode
                  ? _c(
                      "v-flex",
                      { attrs: { shrink: "" } },
                      [
                        _vm.fkTypes[index] === "image"
                          ? _c("v-img", {
                              attrs: {
                                "aspect-ratio": 1.7,
                                height: 50,
                                width: 50,
                                src: _vm.fkFileBase64[index],
                                alt: "icon"
                              }
                            })
                          : _c(
                              "v-icon",
                              { attrs: { large: "", color: "primary" } },
                              [_vm._v("description")]
                            )
                      ],
                      1
                    )
                  : _c(
                      "v-flex",
                      { attrs: { shrink: "" } },
                      [
                        _c("v-img", {
                          attrs: {
                            "aspect-ratio": 1.7,
                            height: 50,
                            width: 50,
                            src: _vm.value[index].file,
                            alt: "icon"
                          }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { staticClass: " ml-2" },
                  [
                    _vm.fkEditIndex !== index
                      ? _c(
                          "v-layout",
                          {
                            style: {
                              "max-width": _vm.$vuetify.breakpoint.smAndDown
                                ? "calc(60vw - 100px)"
                                : "calc(20vw - 100px)"
                            },
                            attrs: { column: "" }
                          },
                          [
                            _c("strong", { staticClass: "black--text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.lblSetting.document_headers.filename
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "grey--text sub-title--text filename--container__text"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(filename) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("strong", { staticClass: "black--text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(_vm.lblSetting.document_headers.ref)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "grey--text sub-title--text filename--container__text"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.fkFileRefs[index]
                                        ? _vm.fkFileRefs[index]
                                        : "-"
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.attributes, function(
                              attribute,
                              indexAttr
                            ) {
                              return _c(
                                "div",
                                [
                                  _c("base-attribute-value", {
                                    attrs: {
                                      attribute: attribute,
                                      attrValue:
                                        _vm.fkFileAttr[index][indexAttr].value
                                    }
                                  })
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _c(
                          "v-layout",
                          { attrs: { column: "" } },
                          [
                            _c(
                              "base-control-label-vertical",
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  label:
                                    _vm.lblSetting.document_headers.filename
                                }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "mt-0 pt-0",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    counter: _vm.textConfigs.input,
                                    maxlength: _vm.textConfigs.input,
                                    clearable: "",
                                    solo: ""
                                  },
                                  model: {
                                    value: _vm.fkEditModel,
                                    callback: function($$v) {
                                      _vm.fkEditModel = $$v
                                    },
                                    expression: "fkEditModel"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "base-control-label-vertical",
                              {
                                attrs: {
                                  label: _vm.lblSetting.document_headers.ref
                                }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "mt-0 pt-0",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    counter: _vm.textConfigs.input,
                                    maxlength: _vm.textConfigs.input,
                                    clearable: "",
                                    solo: ""
                                  },
                                  model: {
                                    value: _vm.fkEditRef,
                                    callback: function($$v) {
                                      _vm.fkEditRef = $$v
                                    },
                                    expression: "fkEditRef"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.attributes, function(
                              attribute,
                              indexAttr
                            ) {
                              return _c("base-attribute-manager", {
                                key: attribute.id,
                                staticClass: "mt-0",
                                attrs: {
                                  attribute: attribute,
                                  label: attribute.name
                                },
                                model: {
                                  value: _vm.fkFileAttr[index][indexAttr].value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fkFileAttr[index][indexAttr],
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "fkFileAttr[index][indexAttr].value"
                                }
                              })
                            })
                          ],
                          2
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.fkEditIndex !== index
                  ? _c(
                      "v-flex",
                      { attrs: { shrink: "" } },
                      [
                        _c(
                          "v-layout",
                          { attrs: { column: "" } },
                          [
                            _vm.fkTypes[index] === "image"
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-0 pt-0",
                                    attrs: { text: "", icon: "" },
                                    on: {
                                      click: function($event) {
                                        _vm.handleAnnotation(index)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "greyDarker" } },
                                      [_vm._v("gesture")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mt-0 pt-0",
                                attrs: { text: "", icon: "" },
                                on: {
                                  click: function($event) {
                                    _vm.handleEditAttachment(index)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { color: "greyDarker" } },
                                  [_vm._v("edit")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-0 pt-0",
                                    attrs: { text: "", icon: "" },
                                    on: {
                                      click: function($event) {
                                        _vm.handleDeleteAttachment(index)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "greyDarker" } },
                                      [_vm._v("delete")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "v-flex",
                      { attrs: { xs2: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mt-0 pt-0",
                            attrs: { text: "", icon: "" },
                            on: { click: _vm.handleUpdateAttachment }
                          },
                          [
                            _c("v-icon", { attrs: { color: "greyDarker" } }, [
                              _vm._v("done")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
              ],
              1
            ),
            _vm._v(" "),
            index < _vm.fkFilenames.length - 1 ? _c("v-divider") : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("input", {
        ref: "addDocInput",
        staticClass: "hidden-screen-only",
        attrs: {
          type: "file",
          accept: _vm.accept,
          multiple: _vm.multiple,
          id: "add-doc-input"
        }
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            bottom: "",
            right: "",
            color: _vm.snackbar.color,
            timeout: _vm.snackbar.timeout
          },
          model: {
            value: _vm.snackbar.open,
            callback: function($$v) {
              _vm.$set(_vm.snackbar, "open", $$v)
            },
            expression: "snackbar.open"
          }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.snackbar.text) + "\n      "),
          _c(
            "v-btn",
            {
              attrs: {
                color: _vm.snackbar.color === "error" ? "white" : "secondary",
                flat: ""
              },
              on: {
                click: function($event) {
                  _vm.snackbar.open = false
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t(_vm.lblSetting.btnClose)) +
                  "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          key: _vm.annotationComponentId,
          attrs: { persistent: "", width: "90%" },
          model: {
            value: _vm.annotationModal,
            callback: function($$v) {
              _vm.annotationModal = $$v
            },
            expression: "annotationModal"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { height: "90vh" } },
            [
              _c(
                "v-layout",
                { attrs: { column: "", "fill-height": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass:
                                "primary--text pa-0 modal-title--icon"
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "pa-0",
                                  attrs: { large: "", color: "primary" }
                                },
                                [_vm._v("gesture")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "headline primary--text modal-title--text"
                            },
                            [_vm._v("Annotations")]
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.closePhotoEditor()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("icon-close")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      attrs: { id: "editor_container" }
                    })
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74646e34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74646e34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/attachment-button/template.html
// module id = null
// module chunks = 